import actionTypes from '../constants/action-types';

const updateCustomColorPalette = (palette) => ({
  type: actionTypes.UPDATE_CUSTOM_COLOR_PALETTE,
  payload: {
    palette,
  },
});

export default updateCustomColorPalette;
